import { render, staticRenderFns } from "./Invites.vue?vue&type=template&id=2c650e51&"
import script from "./Invites.vue?vue&type=script&lang=js&"
export * from "./Invites.vue?vue&type=script&lang=js&"
import style0 from "./Invites.vue?vue&type=style&index=0&id=2c650e51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports